module.exports = __webpack_public_path__ + "static/media/store-level-3.b014f568.png";